import { LabelValueLower } from './keyvalue';

export const Directions: LabelValueLower[] = [
    { value: '100', label: 'INBOUND' },
    { value: '200', label: 'OUTBOUND' }
];

export interface TelephonyContext {

    identifier?: string;
    triggerMemberId?: string;

    contactId?: string;

    memberGroupHash?: string;
    memberGroupHashSource?: TelephonyMemberItem[];
    memberGroup?: TelephonyMemberItem[];


    tenantId?: string;
    direction?: string;
    directionId?: string;

    originId?: number;
    origin?: string;

    reasonId?: number;
    reason?: string;

    notes?: string;
    metaData?: { [key: string]: any };
    skillname?: string;

    dispositionId?: string;
    dispositionIdentifier?: number;

    $created?: Date;
    $lastUpdate?: Date;

    paramsHash?: string;
    paramsDate?: Date;

}

export interface TelephonyContextRequest extends TelephonyContext {
    id: string;
    memberId: string;
    base64: string;
    completed: boolean;
}

export interface TelephonyContextResponse {
    agentId: string;
    contactId: string;
    createdOn: Date;
    direction: string;
    dispositionId: string;
    id: string;
    lastModifiedOn: Date;
    memberId: Date;
    metaData: any;
    originId: number;
    reasonId: number;
}

export interface TelephonySession {
    identifier: string;
    memberGroupHash?: string;
    memberId?: string;
    base64?: string;
    telephonyId?: string;
    tenantId?: string;
    completed?: boolean;
}

export interface TelephonyMemberItem {

    id: string;
    telephonyRecordId?: string;
    status?: 'active' | 'finished';
    $created: Date;
    $lastUpdate: Date;
}


export interface TelephonyMemberGroupHashData {
    memberGroupHash?: string;
    memberGroup?: TelephonyMemberItem[];
}
